import React from 'react';
import moment from 'moment';

function dateToConvert(date) {
	const convertedDate = moment(date)
		.format('ddd DD MMM YYYY hh:mm:ss A')
		.toLocaleString('en-US', {
			hour: 'numeric',
			hour12: true,
		});
	return convertedDate;
}

export function PatientDetails(patients) {
	return (
		patients &&
		patients.map((v, i) => {
			return (
				<tr key={i} className="table-text">
					<td>{v.patient_name}</td>
					<td className="overflow-handling">{dateToConvert(v.date_created)}</td>
				</tr>
			);
		})
	);
}



// WEBPACK FOOTER //
// ./src/screens/MyPatients/MyPatientHelpers.js